import React, { useState, useEffect } from "react";
import "./App.css";
import "./styles/projectsoftpower.css";
import "./styles/modern-2026.css";
import "./styles/cultural-platform.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SplashScreen from "./components/SplashScreen";
import HeaderModern from "./components/HeaderModern";
import FooterModern from "./components/FooterModern";
import HomeModern from "./pages/HomeModern";
import AboutEnhanced from "./pages/AboutEnhanced";
import Arts from "./pages/Arts";
import Films from "./pages/Films";
import Culture from "./pages/Culture";
import TeamUpdated from "./pages/TeamUpdated";
import Contact from "./pages/Contact";
import Submissions from "./pages/Submissions";
import WhatIsSoftPower from "./pages/WhatIsSoftPower";
import OneSharedResponsibility from "./pages/OneSharedResponsibility";
import ArtsFilmsCulture from "./pages/ArtsFilmsCulture";
import LatestRelease from "./pages/LatestRelease";

// ScrollToTop component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const hasSeenSplash = sessionStorage.getItem('hasSeenSplash');
    if (hasSeenSplash) {
      setShowSplash(false);
    }
  }, []);

  const handleEnterSite = () => {
    sessionStorage.setItem('hasSeenSplash', 'true');
    setShowSplash(false);
  };

  return (
    <div className="App">
      {showSplash && <SplashScreen onEnter={handleEnterSite} />}
      <BrowserRouter>
        <ScrollToTop />
        <HeaderModern />
        <main>
          <Routes>
            <Route path="/" element={<HomeModern />} />
            <Route path="/about" element={<AboutEnhanced />} />
            <Route path="/arts" element={<Arts />} />
            <Route path="/films" element={<Films />} />
            <Route path="/culture" element={<Culture />} />
            <Route path="/team" element={<TeamUpdated />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/submissions" element={<Submissions />} />
            <Route path="/what-is-soft-power" element={<WhatIsSoftPower />} />
            <Route path="/one-shared-responsibility" element={<OneSharedResponsibility />} />
            <Route path="/arts-films-culture" element={<ArtsFilmsCulture />} />
            <Route path="/latest-release" element={<LatestRelease />} />
          </Routes>
        </main>
        <FooterModern />
      </BrowserRouter>
    </div>
  );
}

export default App;
